import { Descriptions } from "@/components/v2";
import { Affiliate } from "@rumble-it/common-lib/types/models/Affiliate.interface";
import { Card } from "@rumbledirect/ui";

interface AffiliateDetailCardProps {
  loading: boolean;
  affiliate?: Affiliate;
}

export const AffiliateDetailCard = ({
  loading,
  affiliate,
}: AffiliateDetailCardProps) => {
  return (
    <Card loading={loading} title="Affiliate">
      <Descriptions
        items={[
          {
            label: "Naam",
            children: affiliate?.name,
          },
          {
            label: "E-mail",
            children: affiliate?.email ? (
              <a href={`mailto:${affiliate.email}`}>{affiliate.email}</a>
            ) : null,
          },
          {
            label: "Slug",
            children: affiliate?.slug,
          },
        ]}
      />
    </Card>
  );
};
